import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
// @ts-expect-error - Automatic, Please fix when editing this file
import fetch from 'node-fetch';

import browserUtil from '../../utils/browser';
import config from '../../config';
import getIsServer from '../../utils/get-is-server';

const createClient = () => {
  const isServer = getIsServer();
  const cache = new InMemoryCache();
  if (!isServer) {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property '__APOLLO_STATE__' does not exist on type 'WindowType | { __productReviewCallbackQueue: { push: LodashNoop; }; __productReviewSettings: {}; activeElement: null; addEventListener: LodashNoop; ... 9 more ...; supports: LodashNoop; }'.
    cache.restore(browserUtil.getWindow()?.__APOLLO_STATE__);
  }
  const apiUrl = config.get('api:url');
  const linkOpts = { fetch, uri: `${apiUrl}/graphql` };
  const opts = {
    cache,
    link: createHttpLink(linkOpts),
    name: config?.data?.app,
    ssrMode: isServer,
  };
  return new ApolloClient(opts);
};

const client = createClient();
export default client;
